import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { Outline } from '@cinch/oxd-components/button/src'
import { actions as authActions } from '@cinch/oxd-redux/auth/src'

interface PropsFromState {
  isAuthenticated: boolean
}

interface PropsFromDispatch {
  handleLogout: () => Dispatch
}

export const mapStateToProps = (state: any): PropsFromState => ({
  isAuthenticated: !!(state.oidc && state.oidc.user),
})

export const mapDispatchToProps = (dispatch: any): PropsFromDispatch => ({
  handleLogout: () => dispatch(authActions.logout()),
})

const Component: React.FC<{
  isAuthenticated: boolean
  handleLogout: () => void
}> = ({ handleLogout }) => {
  return (
    <Outline isFullWidth={true} onClick={handleLogout}>
      Log out
    </Outline>
  )
}

export default connect<PropsFromState, PropsFromDispatch, any, any>(mapStateToProps, mapDispatchToProps)(Component)
